import { jsx as _jsx } from "react/jsx-runtime";
import { useCheckboxGroup } from '@chakra-ui/react';
import { useEffect, useMemo } from 'react';
import { BlockErrors, CheckboxItem, InputGroupBase } from '@/components';
import { useResolveValue } from '@/hooks';
import { ValuesType } from '@/types';
import { filterBlockAnswers, getInputBlockAnswer } from '@/utils';
import { BlockLayout } from '../fragments/BlockLayout';
export const CheckboxGroup = (props) => {
    const { answerKey, block, defaultValue = [], errors = [], onChange } = props;
    const { answer_filters = [], answers = [], id, images = [], key, layout, max } = block;
    const { getCheckboxProps, setValue, value: checkedList } = useCheckboxGroup({ defaultValue: [] });
    const [resolver] = useResolveValue();
    const resolved = useMemo(() => {
        const answerKeys = resolver.resolveAnswerFilter(answer_filters);
        const filters = filterBlockAnswers(answers, answerKeys, defaultValue);
        const answersList = filters.answersFiltered.map((a, order) => {
            return Object.assign(Object.assign({}, a), { label: resolver.resolveString(a.label), order });
        });
        return {
            answersList
        };
    }, [block, defaultValue, resolver]);
    useEffect(() => {
        if (!Array.isArray(answerKey) || answerKey.length === 0) {
            setValue([]);
            return;
        }
        const mapped = answerKey
            .map((k) => {
            const match = resolved.answersList.find((a) => a.key === k);
            return match ? match.id : null;
        })
            .filter((v) => v !== null);
        const current = Array.isArray(checkedList) ? checkedList : [];
        const same = mapped.length === current.length && mapped.every((v, i) => v === current[i]);
        if (!same)
            setValue(mapped);
    }, [answerKey, resolved.answersList]);
    const isDisabled = (val) => !checkedList.includes(val) && checkedList.length >= max;
    const handleChange = (answer) => {
        const newAnswer = getInputBlockAnswer(ValuesType.STRING, answer, key);
        const hasCapacity = checkedList.length < max;
        const isUnchecking = (answer === null || answer === void 0 ? void 0 : answer.value) === null;
        if (hasCapacity || isUnchecking) {
            onChange(newAnswer, {
                multipleAnswer: true,
                order: answer.order
            });
        }
    };
    return (_jsx(BlockErrors, Object.assign({ errors: errors }, { children: _jsx(BlockLayout, Object.assign({ layout: layout }, { children: _jsx(InputGroupBase, Object.assign({ "data-test": id }, { children: resolved.answersList.map((item) => {
                    return (_jsx(CheckboxItem, Object.assign({ answer: item, answerChange: handleChange, images: images, isDisabled: isDisabled(item.id) }, getCheckboxProps({ value: item.id })), item.id));
                }) })) })) })));
};
